import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Add this import at the top
import { toast } from "react-toastify";

// eslint-disable-next-line no-unused-vars
import { useAuth } from ".././hook/useAuth";
import { useRef } from "react";
import axiosInstance from "../Help/AxiosLogicInstance";
// import { State, City } from "country-state-city"; // Import the country-state-city package

const InternshipResearchForm = () => {
  const navigate = useNavigate();
  const StudentId = localStorage.getItem("StudentId")
   const [isFormActive, setIsFormActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  // Check if the form is active
  useEffect(() => {
    const checkFormStatus = async () => {
      try {
        const response = await axiosInstance.get('/api/Student/GetApplicationSettingMasterByFormId/2');
        if (response.data && 
            response.data.Status === "200" && 
            response.data.Data && 
            response.data.Data.length > 0) {
          setIsFormActive(response.data.Data[0].IsActive);
        } else {
          setIsFormActive(false);
        }
      } catch (error) {
        console.error("Error fetching form status:", error);
        setIsFormActive(false);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkFormStatus();
  }, [navigate]);
  
  // If form is not active, redirect to internship program page
  useEffect(() => {
    if (!isLoading && !isFormActive) {
      toast.error("Applications are currently closed. Please check back later.");
      navigate('/internship-program');
    }
  }, [isFormActive, isLoading, navigate]);

  // Get all Indian states using the country-state-city package
  // const indianStates = State.getStatesOfCountry("IN");

  // Add state for city/district options
  const [cityOptions, setCityOptions] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [indianStates, setIndianStates] = useState([]);
  useEffect(() => {
    document.title = "Internship Research Application - MedEngage";
  }, []);
  useEffect(() => {
    const loadStatesData = async () => {
      try {
        const response = await fetch('/Districts/states_districts.csv');
        const text = await response.text();
        const lines = text.split('\n').slice(1); // Skip header
        const data = lines.map(line => {
          const [state, district] = line.split(',').map(s => s.replace(/"/g, '').trim());
          return { state, district };
        }).filter(item => item.state && item.district);
        setStatesData(data);
        const uniqueStates = [...new Set(data.map(item => item.state))].sort();
        setIndianStates(uniqueStates);
      } catch (error) {
        console.error('Error loading states data:', error);
      }
    };
    loadStatesData();
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    email: "",
    contactNumber: "",
    collegeName: "",
    collegeID: null,
    collegeAddress: "",
    qualification: "",
    courseYear: "",
    city: "",
    state: "",
    pincode: "",
    duration: "",
    theme: "",
    rationale: "",
    careerImpact: "",
    sourceInfo: "",
    labLocation: "",
    applicantSignature: null,
    agreeTerms: false,
    signatureDeclaration: false,
  });
  useEffect(() => {
    if (formData.state && statesData.length > 0) {
      const districts = statesData
        .filter(item => item.state === formData.state)
        .map(item => item.district)
        .sort();
      setCityOptions(districts);
    } else {
      setCityOptions([]);
    }
  }, [formData.state, statesData]);
  const fieldRefs = {
    name: useRef(),
    email: useRef(),
    collegeName: useRef(),
    collegeID: useRef(),
    collegeAddress: useRef(),
    qualification: useRef(),
    courseYear: useRef(),
    city: useRef(),
    state: useRef(),
    pincode: useRef(),
    duration: useRef(),
    theme: useRef(),
    rationale: useRef(),
    careerImpact: useRef(),
    sourceInfo: useRef(),
    labLocation: useRef(),
    applicantSignature: useRef(),
    agreeTerms: useRef(),
    signatureDeclaration: useRef(),
  };
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // Helper function for detecting leading/trailing spaces
  function hasLeadingOrTrailingSpace(str) {
  return typeof str === "string" && str.trim() !== str;
}


  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    let updatedValue;

    if (type === "checkbox") {
      updatedValue = checked;
    } else if (type === "file") {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png"];
      if (file && file.size > 10 * 1024 * 1024) {
        toast.error("File must be ≤ 10MB");
        // Clear the file input so user can re-select
        e.target.value = "";
        return;
      }
      if (file && !validTypes.includes(file.type)) {
        toast.error("Invalid file type. Only JPG, PNG allowed");
        e.target.value = "";
        return;
      }
      updatedValue = file;
    } else if (
      type === "text" ||
      type === "email" ||
      type === "tel" ||
      name === "rationale" ||
      name === "careerImpact" ||
      name === "collegeAddress"
    ) {
      // We allow spaces during typing (like "Shilpa A" with space between)
      // The trimming and toast happens in handleBlur when user finishes typing
      updatedValue = value;
    } else {
      updatedValue = value;
    }

    // Special handling for state selection
    if (name === "state") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        city: "", // Reset city when state changes
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    }

    // Clear the error for this field as soon as user types/selects
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };
  function handleBlur(e) {
    const { name, value } = e.target;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed !== value) {
        // update local form state
        setFormData((prev) => ({ ...prev, [name]: trimmed }));
        // Show field-specific toast message
        // toast.warning(`Leading or trailing spaces removed from ${name}`);
      }
    }

    // run validation after trimming
    setSubmitted(true);
    validate();
  }
  // ...existing code...

  const validate = () => {
    let tempErrors = {};

    // Required fields
    const requiredFields = [
      "name",
      "email",
      "collegeName",
      "collegeID",
      "collegeAddress",
      "qualification",
      "courseYear",
      "city",
      "state",
      "pincode",
      "duration",
      "theme",
      "rationale",
      "careerImpact",
      "sourceInfo",
      "labLocation",
      "applicantSignature",
      "agreeTerms",
      "signatureDeclaration",
    ];

    requiredFields.forEach((field) => {
      const value = formData[field];
      // Check for empty, null, or only spaces
      if (
        value === "" ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (typeof value === "boolean" && !value)
      ) {
        tempErrors[field] = "Required";
      }
      // Field is required check only - we'll handle spaces separately
    });

    // Name validation - only alphabets and spaces
    if (formData.name && !/^[A-Za-z ]+$/.test(formData.name.trim())) {
      tempErrors.name = "Only alphabets and spaces allowed";
    }

    // Email validation with proper regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (formData.email) {
      // Check for spaces in email
      if (!emailRegex.test(formData.email)) {
        tempErrors.email = "Invalid email format (e.g., abc@test.com)";
      }
    }

    // Phone number validation (India format)
    const phoneRegex = /^(\+91\s?)?\d{5}\s?\d{5}$/;
    if (
      formData.contactNumber &&
      !phoneRegex.test(formData.contactNumber.trim())
    ) {
      tempErrors.contactNumber = "Use: +91 91522 11510 or 9152211510";
    }

    // College name validation - only alphabets and spaces
    if (
      formData.collegeName &&
      !/^[A-Za-z .,'()-]+$/.test(formData.collegeName.trim())
    ) {
      tempErrors.collegeName = "Only letters, spaces and . , ' ( ) - allowed";
    }
    if (!formData.signatureDeclaration) {
      tempErrors.signatureDeclaration =
        "Consent statements should be mandatory";
    }

    if (!formData.agreeTerms) {
      tempErrors.agreeTerms = "Consent statements should be mandatory";
    }

    // College address validation - allow only alphanumeric + basic punctuation
    const addressRegex = /^[a-zA-Z0-9\s,.\-\/#()]+$/;
    if (
      formData.collegeAddress &&
      !addressRegex.test(formData.collegeAddress.trim())
    ) {
      tempErrors.collegeAddress =
        "Address can only contain letters, numbers, spaces, and basic punctuation (,.-/#())";
    }

    /*   // Course year validation - only numeric input
  if (formData.courseYear && !/^\d+$/.test(formData.courseYear.trim())) {
    tempErrors.courseYear = "Only numeric values allowed";
  }
 */
    // Course year validation - dropdown
    if (!formData.courseYear) {
      tempErrors.courseYear = "Course year is required";
    }

    // Pincode validation (6 digits)
    if (formData.pincode && !/^\d{6}$/.test(formData.pincode.trim())) {
      tempErrors.pincode = "Pincode should be exactly 6 digits";
    }

    // Date of birth validation
    if (formData.dob) {
      const dobDate = new Date(formData.dob);
      const today = new Date();
      if (dobDate > today) {
        tempErrors.dob = "Date of birth cannot be in the future";
      }
    }

    // Check ALL string fields for leading/trailing spaces
    // This runs AFTER all the specific validations above, so field-specific errors have priority
    Object.keys(formData).forEach((field) => {
      const val = formData[field];
      if (typeof val === "string" && val && hasLeadingOrTrailingSpace(val)) {
        // Only set this generic error if no specific error exists for this field
       
          // Note: The actual trimming and toast happens in handleBlur, not here
        
      }
    });
    setErrors(tempErrors);
    console.log("Validation errors:", tempErrors);
    return tempErrors;
  };

  // ...existing code...

  // ...existing code...

  const handleSubmit = async (e) => {
    e.preventDefault();

    // If already loading, prevent multiple submissions
    if (loading) {
      return;
    }

    setSubmitted(true);
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      // Set loading state to prevent multiple submissions
      setLoading(true);

      try {
        console.log("Validation passed, calling API");
        // Prepare the payload as per your API
        let applicantSignatureBase64 = "";
        if (formData.applicantSignature) {
          const reader = new FileReader();
          applicantSignatureBase64 = await new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(formData.applicantSignature);
          });
        }
        let CompanyidBase64 = "";
        if (formData.collegeID) {
          const reader = new FileReader();
          CompanyidBase64 = await new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(formData.collegeID);
          });
        }

        const studentId = localStorage.getItem("StudentId");
        const payload = {
          Id: 0,
          InternshipName: formData.name,
          InternshipEmail: formData.email,
          College: formData.collegeName,
          OtherCollege: "",
          Qualification: formData.qualification,
          CourseYear: formData.courseYear,
          ContactNumber: formData.contactNumber,
          City: formData.city,
          State: formData.state,
          Pincode: formData.pincode,
          Address: formData.collegeAddress,
          DurationInternship: formData.duration,
          ThemeInternship: formData.theme,
          OtherThemeInternship: "",
          AboutInternshipProgram: formData.sourceInfo, // Use sourceInfo here
          ReasonForInternship: formData.rationale,
          StudentId: studentId,
          OtherQualification:
            formData.qualification === "Other" ? "Please specify" : "",
          Rational: formData.rationale,
          MhlLocations: formData.labLocation,
          Dob: formData.dob,
          CollegeId: CompanyidBase64,

          // Add the new fields that match the API
          ApplicantSignature: applicantSignatureBase64,
          CareerImpact: formData.careerImpact,
          SourceInfo: formData.sourceInfo,
          AgreeTerms: formData.agreeTerms,
          SignatureDeclaration: formData.signatureDeclaration,

          // Include these for the API
          CreatedAt: new Date().toISOString(),
          UpdatedAt: new Date().toISOString(),
        };

        // Correct axios usage: just pass the payload
        const response = await axiosInstance.post(
          "/api/Student/InternshipApplication",
          payload
        );

        if (response.data.Status === "200") {
          // Use the reference ID from the API response
          const referenceId = response.data.ReferenceId;

          toast.success("Application submitted successfully!");
          navigate("/success", {
            state: {
              referenceId,
              name: formData.name,
              email: formData.email,
              formType: "Internship Research Application",
            },
          });
        } else {
          toast.error(
            response.data.Message || "Application submission failed!"
          );
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An error occurred. Please try again.");
      } finally {
        // Reset loading state regardless of success or failure
        setLoading(false);
      }
    } else {
      // Find the first error field and scroll to it
      const firstErrorField = Object.keys(validationErrors).find(
        (key) => validationErrors[key]
      );
      if (firstErrorField && fieldRefs[firstErrorField]?.current) {
        fieldRefs[firstErrorField].current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        fieldRefs[firstErrorField].current.focus();
      }
      toast.error("Please fill all required fields correctly.");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container-fluid py-5">
      {isLoading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Checking application status...</p>
        </div>
      ) : isFormActive ? (
        <div className="form-container">
          <h2 className="text-center form-heading">
            <span className="green">Internship Research</span> Application
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="section-header">Basic Information</div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your name"
                  ref={fieldRefs.name}
                />
                {submitted && errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">Date of Birth</label>
                <input
                  type="date"
                  className="form-control"
                  name="dob"
                  max={new Date().toISOString().split("T")[0]}
                  value={formData.dob}
                  onChange={handleChange}
                  placeholder="dd-mm-yyyy"
                  ref={fieldRefs.dob}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Email<span className="required">*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your email"
                  ref={fieldRefs.email}
                />
                {submitted && errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">Contact Number</label>
                <input
                  type="tel"
                  className="form-control"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your contact number"
                  ref={fieldRefs.contactNumber}
                />
                {submitted && errors.contactNumber && (
                  <small className="text-danger">{errors.contactNumber}</small>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">
                  College Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="collegeName"
                  value={formData.collegeName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your college name"
                  ref={fieldRefs.collegeName}
                />
                {submitted && errors.collegeName && (
                  <small className="text-danger">{errors.collegeName}</small>
                )}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Upload College ID <span className="required">*</span>
                </label>
                <div className="file-upload-wrapper">
                  <label className="file-upload-btn">
                    <i className="fa fa-upload"></i>
                    Upload College ID
                    <input
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      name="collegeID"
                      onChange={handleChange}
                      onBlur={() => {
                        setSubmitted(true);
                        validate();
                      }}
                      ref={fieldRefs.collegeID}
                    />
                  </label>
                  <small className="form-text text-muted">
                    Accepted formats: jpg, png, Max 10 MB
                  </small>
                  {/* Show selected file name */}
                  {formData.collegeID && (
                    <div className="mt-1 text-success">
                      Selected file: {formData.collegeID.name}
                    </div>
                  )}
                  {submitted && errors.collegeID && (
                    <small className="text-danger d-block">
                      {errors.collegeID}
                    </small>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">
                  College Address<span className="required">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="collegeAddress"
                  value={formData.collegeAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your college address"
                  ref={fieldRefs.collegeAddress}
                ></textarea>
                {submitted && errors.collegeAddress && (
                  <small className="text-danger">{errors.collegeAddress}</small>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Qualification<span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  name="qualification"
                  value={formData.qualification}
                  onChange={handleChange}
                  ref={fieldRefs.qualification}
                >
                  <option value="">Select Qualification</option>
                  <option value="MBBS">MBBS</option>
                  <option value="BSc">BSc</option>
                  <option value="Other">Other</option>
                </select>
                {submitted && errors.qualification && (
                  <small className="text-danger">{errors.qualification}</small>
                )}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Course Year<span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  name="courseYear"
                  value={formData.courseYear || ""}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  ref={fieldRefs.courseYear}
                >
                  <option value="">Select your course year</option>
                  <option value="1st Year MBBS">1st Year MBBS</option>
                  <option value="2nd Year MBBS">2nd Year MBBS</option>
                  <option value="3rd Year MBBS">3rd Year MBBS</option>
                  <option value="4th Year MBBS">4th Year MBBS</option>
                  <option value="Internships">Internships</option>
                  <option value="PGs (MD/MS and DNB)">
                    PGs (MD/MS and DNB)
                  </option>
                </select>
                {submitted && errors.courseYear && (
                  <small className="text-danger">{errors.courseYear}</small>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">
                  State<span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  name="state"
                  value={formData.state || ""}
                  onChange={handleChange}
                  ref={fieldRefs.state}
                >
                  <option value="">Select State</option>
                  {indianStates.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
                {submitted && errors.state && (
                  <small className="text-danger">{errors.state}</small>
                )}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  City<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  ref={fieldRefs.city}
                  placeholder="Enter city"
                />
                {submitted && errors.city && (
                  <small className="text-danger">{errors.city}</small>
                )}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Pincode<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your pincode"
                  ref={fieldRefs.pincode}
                />
                {submitted && errors.pincode && (
                  <small className="text-danger">{errors.pincode}</small>
                )}
              </div>
            </div>

            {/* Internship Details */}
            <div className="section-header">Internship Details</div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Duration of Internship<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter duration (ex: 2 months)"
                  ref={fieldRefs.duration}
                />
                {submitted && errors.duration && (
                  <small className="text-danger">{errors.duration}</small>
                )}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Choose a Theme / Dept of Lab medicine for Internship
                  <span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  name="theme"
                  value={formData.theme}
                  onChange={handleChange}
                  ref={fieldRefs.theme}
                >
                  <option value="">Select your option</option>
                  <option value="Clinical Chemistry">Clinical Chemistry</option>
                  <option value="Hematology">Hematology</option>
                  <option value="Microbiology">Microbiology</option>
                  <option value="Other">Other</option>
                </select>
                {submitted && errors.theme && (
                  <small className="text-danger">{errors.theme}</small>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">
                  How did you come to know about Metropolis Internship Program?
                  <span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  name="sourceInfo"
                  value={formData.sourceInfo}
                  onChange={handleChange}
                  ref={fieldRefs.sourceInfo}
                >
                  <option value="">Select option</option>
                  <option value="Website">Website</option>
                  <option value="Social Media">Social Media</option>
                  <option value="College">College</option>
                  <option value="Other">Other</option>
                </select>
                {submitted && errors.sourceInfo && (
                  <small className="text-danger">{errors.sourceInfo}</small>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label d-flex justify-content-between align-items-center">
                  <span>
                    MHL Laboratory location Where Observership is Desired
                    <span className="text-danger ms-1">*</span>
                  </span>
                  <a
                    href="https://www.metropolisindia.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-success"
                  >
                    (Please visit Metropolis India)
                  </a>
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="labLocation"
                  value={formData.labLocation}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="MHL laboratory locations"
                  ref={fieldRefs.labLocation}
                />
                {submitted && errors.labLocation && (
                  <small className="text-danger">{errors.labLocation}</small>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Upload Applicant Signature<span className="required">*</span>
                </label>
                <div className="file-upload-wrapper">
                  <label className="file-upload-btn">
                    <i className="fa fa-upload"></i>
                    Choose File
                    <input
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      name="applicantSignature"
                      onChange={handleChange}
                      ref={fieldRefs.applicantSignature}
                    />
                  </label>
                  <small className="form-text text-muted">
                    (Accepted formats: .jpg, .jpeg, .png, Max 10 MB)
                  </small>
                  {formData.applicantSignature && (
                    <div className="mt-1 text-success">
                      Selected file: {formData.applicantSignature.name}
                    </div>
                  )}
                  {submitted && errors.applicantSignature && (
                    <small className="text-danger d-block">
                      {errors.applicantSignature}
                    </small>
                  )}
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  In 100 words share your rationale for your Internship
                  <span className="required">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="rationale"
                  value={formData.rationale}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  ref={fieldRefs.rationale}
                ></textarea>
                {submitted && errors.rationale && (
                  <small className="text-danger">{errors.rationale}</small>
                )}
              </div>

              <div className=" mb-3">
                <label className="form-label">
                  How will this Internship help you in your / career as Health
                  care professional<span className="required">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="careerImpact"
                  value={formData.careerImpact}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  ref={fieldRefs.careerImpact}
                ></textarea>
                {submitted && errors.careerImpact && (
                  <small className="text-danger">{errors.careerImpact}</small>
                )}
              </div>
            </div>

            <div className="form-check mb-2">
              <input
                type="checkbox"
                className="form-check-input"
                name="agreeTerms"
                checked={formData.agreeTerms}
                onChange={handleChange}
                ref={fieldRefs.agreeTerms}
              />
              <label className="form-check-label">
                I confirm that all details provided in this application form are
                true to the best of my knowledge.<span className="required">*</span>
              </label>
              {submitted && errors.agreeTerms && (
                <small className="text-danger">{errors.agreeTerms}</small>
              )}
            </div>
            <div className="form-check mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                name="signatureDeclaration"
                checked={formData.signatureDeclaration}
                onChange={handleChange}
                ref={fieldRefs.signatureDeclaration}
              />
              <label className="form-check-label">
                My signature is attached, and I adhere to the above declarations.
                <span className="required">*</span>
              </label>
              {submitted && errors.signatureDeclaration && (
                <small className="text-danger">
                  {errors.signatureDeclaration}
                </small>
              )}
            </div>
            <div
              class="alert alert-info d-flex align-items-center"
              role="alert"
            >
              <i class="fa fa-sticky-note me-2" aria-hidden="true"></i>
              <strong>Note:</strong> Please review the form carefully before
              submitting.
            </div>
            <div className="text-center mt-2">
              <button
                type="submit"
                className="btn btn-outline-success submit-btn rounded-3"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submitting...
                  </>
                ) : (
                  <>
                    <i className="fa fa-paper-plane me-2"></i>Submit Application
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="alert alert-danger text-center my-5">
          <i className="fa fa-exclamation-circle me-2"></i>
          Applications are currently closed. Please check back later.
        </div>
      )}
    </div>
  );
};

export default InternshipResearchForm;
